<div>
  <h1 class="main-title">
    <div class="circle circle-primary">
      <img src="assets/icons/toolbox-icon.svg" alt="">
    </div>
    Tipos de envases
  </h1>
  <div class="flex justify-between items-center mb-2">
    <h2 class="main-subtitle">Nuevo tipo de envase</h2>
    <a routerLink="/container-types" class="button button-outlined-primary">
      <i class="fa-solid fa-chevron-left" alt=""></i> Volver
    </a>
  </div>

  <div class="single-page-content">
    <form [formGroup]="containerTypeForm" (ngSubmit)="onSubmit()">
      <div class="mb-4">
        <label for="name" class="block text-sm font-bold mb-2">Nombre<span class="text-danger-500">*</span>:</label>
        <input id="name" type="text" formControlName="name" class="input" placeholder="Nombre">
        <div *ngIf="name?.invalid && (name?.dirty || name?.touched)" class="text-danger-500 text-sm">
          El nombre es obligatorio.
        </div>
      </div>
      <div *ngIf="errorMessage" class="mb-4 text-danger-500">
        {{ errorMessage }}
      </div>
      <div class="flex items-center justify-end">
        <button type="submit" class="button button-success">
          Crear tipo de mantención
        </button>
      </div>
    </form>
  </div>
</div>
